export interface ShopToClubConfigState {
    isEnabled: boolean;
    mobileImage: string;
    mobileDelayInSeconds: number;
    expirationInDays: number;
    topBorderColor: string;
    isDismissable: boolean;
    promoExpirationTime: number;
    isUndismissableFromOutsideClick: boolean;
    pageViewLimit: string;
}

export interface ClubHighlightTabState {
    toggle: boolean;
}

export interface MagalogState {
    toggle: boolean;
    url: string;
}

export interface MoodboardState {
    enableMobileEntry: boolean;
}

export interface SpecialSalesState {
    strikeThroughColor: string;
    blackFridayBadgeColor: string;
    cyberMondayBadgeColor: string;
}

export enum Positions {
    bottomleft = 'bottomleft',
    bottomright = 'bottomright',
    topleft = 'topleft',
    topright = 'topright',
}

export interface BrazeConfig {
    identifier: string;
    authentication: string;
    authenticationMobile: string;
}

export interface ConfigurationsState {
    shipping: {
        minOrderValue: number | null;
    };
    magalog: MagalogState;
    shopToClub: ShopToClubConfigState;
    moodboard: MoodboardState;
    clubHeaderHighlightTab: ClubHighlightTabState;
    specialSales: SpecialSalesState;
    error?: any;
    isFetching: boolean;
    didInvalidate: boolean;
    identifier: string;
    isImageServiceProductImageEnabled: boolean;
    quantityBadgePosition: Positions;
    braze: BrazeConfig;
    isNativeVideoPlayerEnabled: boolean;
    isPdpClientSideNavigationEnabled: boolean;
    isPdpTaxDisclaimerEnabled: boolean;
}

export const CONFIG_IDENTIFIER = 'remoteConfig';
export const DISABLE_SHOP_TO_CLUB = 'DISABLE_SHOP_TO_CLUB';
